import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { auth } = useAuth();
  const location = useLocation();
  
  // Mostrar pantalla de carga mientras se inicializa la autenticación
  if (auth.isLoading || !auth.initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }
  
  // Solo redirigir si la autenticación ya se inicializó y el usuario no está autenticado
  if (!auth.isAuthenticated) {
    // Redirigir al login con el parámetro redirect
    return <Navigate to={`/login?redirect=${location.pathname}`} state={{ from: location }} replace />;
  }
  
  return <>{children}</>;
};

export default PrivateRoute; 